export default __webpack_public_path__ + "static/media/synthetix.98f594e6.png";